import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import logoUrl from '../../lendnation-logo-v2.svg';
import infin from '../../infin.svg';

var link = '#';

class Logo extends Component {
  render() {
    return (
      <footer className="apply-now-footer">
        <Row>
          <Col lg="3" xl="3" xxl="3">
            <img
              src={logoUrl}
              alt="CashMax"
              className="img-responsive footer-logo-img"
            />

            <div className="support-label pt-4">
              Customer Support
              <br />
              <strong>866-324-9565</strong>
            </div>

            <div className="pt-4">
              For Payday Loans or Cash
              <br /> Advances in Canada, visit
              <br />
              <a className="speedyCashLink" href={link}>
                Speedy Cash
              </a>
              .
            </div>
            <p className="pt-4">
              <img
                src={infin}
                alt="Infin"
                className="img-responsive"
              />
            </p>
          </Col>
          <Col>
            <div className="footer-menu1">
              <ul className="footer-menu1-ul">
                <li>Disclosures</li>
                <li>Locations</li>
                <li>FAQ</li>
                <li>Blog</li>
                <li>Privacy Policy</li>
                <li>Terms &amp; Conditions</li>
                <li>Site Map</li>
              </ul>
              <hr />
            </div>
            <div className="city-menu">
              <ul className="city-menu-ul">
                <li>Boise, MD</li>
                <li>St. Louis, MO</li>
                <li>Las Vegas, NV</li>
                <li>Louisville, KY</li>
                <li>Memphis, TN</li>
                <li>Milwaukee, WI</li>
                <li>Montgomery, AL</li>
                <li>New Orleans, LA</li>
                <li>Ohlahoma City, OK</li>
                <li>Jackson, MS</li>
                <li>San Antonio, TX</li>
              </ul>
              <ul className="city-menu-ul">
                <li>Salt Lake City, UT</li>
                <li>Wichita, KS</li>
                <li>Kansas City</li>
                <li>Nashville, TN</li>
                <li>Springfield, MO</li>
                <li>El Paso, TX</li>
                <li>Tulsa, OK</li>
                <li>Birmingham, AL</li>
                <li>Ogden, UT</li>
                <li>Gulfport-Biloxi, MS</li>
                <li>Madison, WI</li>
              </ul>
              <ul className="city-menu-ul">
                <li>
                  <span>Topeka, KS</span>
                </li>
                <li>Reno, NV</li>
                <li>Lexington, KY</li>
                <li>Idaho Falls, ID</li>
                <li>Shreveport, LA</li>
              </ul>
            </div>
            <div className="footer-info">
              <p>
                Loans are not available to members of the military.
              </p>
              <p>
                Customer Notice: There are a wide variety of financial
                products available in the marketplace, so your choice
                of such products should match your financial needs.
                Short-term, small dollar credit used over a long
                period of time can be expensive. Certain restrictions
                may apply, including state database and credit
                underwriting standards and limitations. Visit a
                LendNation store or contact us for details.
              </p>
              <p> Photos are not real customers.</p>
              <p>
                Content Copyright&copy; 2025, QCHI LLC | 8208 Melrose
                Dr Lenexa, KS 66214 | All rights reserved.
              </p>
            </div>
          </Col>
        </Row>
      </footer>
    );
  }
}
export default Logo;
